import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { Chat, StartChatResponse } from './models/channels';

export const channels = createApi({
  reducerPath: 'CHATS',
  baseQuery,
  tagTypes: ['Chats'],

  endpoints: builder => ({
    getChat: builder.query<Chat, { chatId: string }>({
      query: variables => ({
        document: gql`
          query GetChat($chatId: String) {
            getChat(chatId: $chatId) {
              guid
              title {
                text
              }
              rooms {
                type
                thirdPartyUid
                participants {
                  role
                  participantId
                  participant {
                    thirdPartyUid
                    guid
                    user {
                      roleId
                      profile {
                        firstname
                        lastname
                        avatar {
                          contentUrl
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `,
        variables,
      }),

      transformResponse: (response: { getChat: Chat }) => response.getChat,
    }),

    startChat: builder.mutation<StartChatResponse, void>({
      query: variables => ({
        document: gql`
          mutation Credentials {
            startChat {
              credentials {
                accessKeyId
                sessionToken
                secretAccessKey
              }
              endpoint {
                Url
              }
              region
            }
          }
        `,
        variables,
      }),

      transformResponse: (response: { startChat: StartChatResponse }) => response.startChat,
    }),

    createChat: builder.mutation<
      Chat,
      {
        chatId: string;
        participantId: string;
      }
    >({
      query: variables => ({
        document: gql`
          mutation CreateChat($chatId: String, $participantId: String) {
            createChat(chatId: $chatId, participantId: $participantId) {
              guid
              title {
                text
              }
              rooms {
                type
                thirdPartyUid
                participants {
                  role
                  participantId
                  participant {
                    thirdPartyUid
                    guid
                    user {
                      roleId
                      profile {
                        firstname
                        lastname
                        avatar {
                          contentUrl
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: { createChat: Chat }) => response.createChat,
    }),
  }),
});

export const { useStartChatMutation, useGetChatQuery, useCreateChatMutation } = channels;
